// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Field, reduxForm } from "redux-form";
import { Dropdown } from "@components/form";
import { Form, FormGroup, Label, Button } from "@components";
import { isOperatingCompany } from "@selectors/index";

type OwnProps = $Exact<{
  handleSubmit: Function,
  options: Object,
  dirty: boolean,
  pristine: boolean,
  reset: () => void,
  onReset: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class ClientFilter extends React.Component<Props> {
  resetForm = () => {
    this.props.reset();
    this.props.onReset();
  };

  get statuses() {
    return this.props.options.status;
  }

  render() {
    return (
      <Form className="d-flex flex-1 my-2" onSubmit={this.props.handleSubmit}>
        <FormGroup className="">
          <Label for="accountManager" className="mr-sm-2">
            {this.props.t("MANAGER")}
          </Label>
          <Field
            id="accountManager"
            name="accountManager"
            className="w-100"
            placeholder={"All"}
            component={Dropdown}
            options={this.props.options.accountManager}
          />
        </FormGroup>
        <FormGroup className={"col-2 px-2"}>
          <Label for="reseller" className="mr-sm-2">
            {this.props.t("OWNER")}
          </Label>
          <Field
            id="reseller"
            name="reseller"
            className="w-100"
            placeholder={"All"}
            component={Dropdown}
            options={this.props.options.reseller}
          />
        </FormGroup>
        <FormGroup className={"col-2 px-2"}>
          <Label for="industry" className="mr-sm-2">
            {this.props.t("INDUSTRY")}
          </Label>
          <Field
            id="industry"
            name="industry"
            className="w-100"
            placeholder={"All"}
            component={Dropdown}
            options={this.props.options.industry}
          />
        </FormGroup>
        <FormGroup className={"col-2 px-2"}>
          <Label for="status" className="mr-sm-2">
            {this.props.t("STATUS")}
          </Label>
          <Field
            id="status"
            name="status"
            className="w-100"
            placeholder={"All"}
            component={Dropdown}
            options={this.statuses}
          />
        </FormGroup>
        <FormGroup className={"d-flex align-items-end form-group col-4 px-2"}>
          <Button materialIcon="replay_circle_filled">{this.props.t("SUBMIT")}</Button>
          {this.props.dirty && (
            <Button color="secondary" onClick={this.resetForm}>
              {this.props.t("RESET")}
            </Button>
          )}
        </FormGroup>
      </Form>
    );
  }
}

export default reduxForm({
  form: "client-filter",
  destroyOnUnmount: false,
  initialValues: {
    status: "ACTIVE",
    is_operating_company: isOperatingCompany(),
  },
})(localize()(ClientFilter));
